import React, { memo } from 'react';
import styled from 'styled-components';
import { withRole } from '../../components/Common/withRole';
import { PrimaryButton } from '../../components/Common/BaseButton';
import { ManagerOnlyAddContactActions } from './AddEventContactActions';
import { Contact } from 'lucide-react';

const ContactInput = styled.input`
  width: 100%;
  padding: 0.4rem 0.7rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 0.3rem;
  font-size: 1rem;
`;

const ContactActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
  margin-top: 0.5rem;
`;

const AddContactForm = ({ 
  newContact, 
  setNewContact, 
  onCancel, 
  onSave, 
  isManager, 
  isAuthenticated 
}) => {
  const handleChange = (field) => (e) => {
    setNewContact(prev => ({ ...prev, [field]: e.target.value }));
  };

  return (
    <div style={{ marginTop: '1rem' }}>
      <ContactInput
        type="text"
        placeholder="Name"
        value={newContact.name}
        onChange={handleChange('name')}
      />
      <ContactInput
        type="text"
        placeholder="Role"
        value={newContact.role}
        onChange={handleChange('role')}
      />
      <ContactInput
        type="tel"
        placeholder="Phone"
        value={newContact.phone}
        onChange={handleChange('phone')}
      />
      <ContactInput
        type="email"
        placeholder="Email"
        value={newContact.email}
        onChange={handleChange('email')}
      />
      <ContactActions>
        <ManagerOnlyAddContactActions 
          onCancel={onCancel}
          onSave={onSave}
          isManager={isManager}
          isAuthenticated={isAuthenticated}
        />
      </ContactActions>
    </div>
  );
};

const AddContactButton = memo(({ onClick, isManager, isAuthenticated }) => {
  const AddButtonContent = () => (
    <PrimaryButton onClick={onClick} style={{ marginTop: '1rem', width: '100%' }}>
      <Contact size={16} /> Add Contact
    </PrimaryButton>
  );

  const WithRoleComponent = withRole(AddButtonContent, { 
    managerOnly: true
  });

  return <WithRoleComponent isManager={isManager} isAuthenticated={isAuthenticated} />;
});

const AddEventContact = ({ 
  isAddingContact,
  newContact,
  setNewContact,
  onCancel,
  onSave,
  isManager,
  isAuthenticated
}) => {
  return isAddingContact ? (
    <AddContactForm
      newContact={newContact}
      setNewContact={setNewContact}
      onCancel={() => onCancel(false)}
      onSave={onSave}
      isManager={isManager}
      isAuthenticated={isAuthenticated}
    />
  ) : (
    <AddContactButton
      onClick={() => onCancel(true)}
      isManager={isManager}
      isAuthenticated={isAuthenticated}
    />
  );
};

export default AddEventContact;
